import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { CardBody, Col, Container } from 'reactstrap'
import NotificationSystem from 'rc-notification'
import { useTranslation } from 'react-i18next'

import { sendEmailToConfirmAccount } from 'Redux/actions/auth'
import { FullWideNotification } from 'Shared/components/Notification'
import IconLinkExpired from 'Shared/icons/svg/icon-link-expired'
import './style.scss'

let notification = null
const showNotification = message => {
  notification.notice({
    content: <FullWideNotification color="success" message={message} />,
    position: 'full',
    duration: 3,
    closable: true,
    style: { left: 0, top: 60 },
    className: `ltr-support`,
  })
}

const ExpiredLinkPage = ({ onSendEmailToConfirmAccount }) => {
  const { t } = useTranslation()

  const handleSendEmail = () => {
    onSendEmailToConfirmAccount()
    NotificationSystem.newInstance({ style: { top: 65 } }, n => {
      notification = n
    })
    showNotification(t('notification.checkEmail'))
  }

  return (
    <Container className="expired_link_page">
      <Col lg={12} md={12} xl={12}>
        <CardBody className="link_expired">
          <IconLinkExpired />
          <h2 style={{ marginBottom: 29 }}>{t('errorsPage.linkHasExpired')}</h2>
          {t('errorsPage.tryingToUseExpiredLink')}
          <br />
          {t('errorsPage.expiresIn24Hours')}
          <br />
          {t('errorsPage.receiveNewLink')}
          <button
            className="btn btn-success btn_link_request"
            type="submit"
            onClick={handleSendEmail}
          >
            {t('errorsPage.requestNewLink')}
          </button>
          {t('errorsPage.ifIssuePersist')}{' '}
          <a
            className="let_us_know"
            href="http://help.soundcamps.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('errorsPage.thenLetUsKnow')}
          </a>
        </CardBody>
      </Col>
    </Container>
  )
}

ExpiredLinkPage.propTypes = {
  onSendEmailToConfirmAccount: PropTypes.func.isRequired,
}

const selector = createStructuredSelector({})

const actions = {
  onSendEmailToConfirmAccount: sendEmailToConfirmAccount,
}

export default compose(connect(selector, actions))(ExpiredLinkPage)
